import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { RentalPolicyResponse } from '../models/rental-policy-response.model';
import { RentalPolicyRepository } from '../repositories/rental-policy.respository';

export class GetRentalPolicyUseCase
    implements UseCase<never, RentalPolicyResponse>
{
    constructor(private readonly repository: RentalPolicyRepository) {}

    execute(): Observable<RentalPolicyResponse> {
        return this.repository.getRentalPolicy();
    }
}
